export default __webpack_public_path__ + "static/media/cwu4.fb6316bd.jpeg";